import withResponsive from '../hoc/withResponsive'
import { get } from '@bigyouth/base'

export default withResponsive({
  name: 'tabs',

  ui: {
    'buttons[]': '[js-tabs-trigger]',
  },

  events: [
    {
      target: 'buttons',
      on: 'click',
      handle (e) {
        const tabId = e.target.dataset.tab

        // change panel
        this.changePanel(tabId)
      },
    },
  ],

  componentDidMount () {
  },

  changePanel (idPanel) {
    const currentPanel = get('[js-tabs-panel].is-active')
    const nextPanel = get(`[js-tabs-panel][data-tab="${idPanel}"]`)
    const currentNavItem = get(`[js-tabs-trigger][data-tab="${idPanel}"]`)

    // nav
    this.el
      .querySelector('[js-tabs-trigger].is-active')
      .classList.remove('is-active')

    currentNavItem.classList.add('is-active')

    // panel
    currentPanel.classList.remove('is-active')
    nextPanel.classList.add('is-active')
  },
})
